import { TextNode, LexicalNode, $isTextNode, $isElementNode, DOMConversionMap, DOMConversion, DOMConversionOutput } from 'lexical';
import { $convertImageElement } from '../nodes/InlineImageNode';

export function forEachDescendantTextNode(node: LexicalNode, fn: (t: TextNode) => void)
{
    if ($isTextNode(node))
    {
        fn(node);
        return;
    }
    if ($isElementNode(node))
    {
        const children: LexicalNode[] = node.getChildren?.() ?? [];
        for (const c of children) { forEachDescendantTextNode(c, fn); }
    }
}

// export function mergeCss(a: string, b: string): string
// {
//     if (!a) return b;
//     if (!b) return a;
//     const map = new Map<string, string>();
//     const put = (css: string) => css.split(';').forEach(r =>
//     {
//         const [p, v] = r.split(':').map(x => x?.trim());
//         if (p && v) map.set(p.toLowerCase(), v);
//     });
//     put(a);
//     put(b);
//     return Array.from(map.entries()).map(([k, v]) => `${k}: ${v}`).join('; ');
// }

export function mergeCss(a: string, b: string): string
{
    return a && b ? `${a}; ${b}` : (a || b || '');
}

export function makeInlineStyleConversion()
{
    return (domNode: Node) =>
    {
        // ważne: NIE wyłączamy domyślnej konwersji (bold/underline itd.),
        // tylko dopinamy „after” – dzięki temu flagi zostają.
        return{
            priority: 3, // wyższy niż domyślne importy dla tych tagów
            conversion: (domNode: Node) =>
            {
                const el = domNode as HTMLElement;
                const style = el.getAttribute('style');
                console.log('makeInlineStyleConversion style=', style);
                // const filteredCss = parseAndFilterCss(el.getAttribute('style') || '');
                return {
                    node: null, // pozwól domyślnej konwersji zrobić swoje (flagi)
                    after: (createdNode: LexicalNode) =>
                    {
                        console.log('makeInlineStyleConversion after style=', style);
                        // if (!style) return;
                        // forEachDescendantTextNode(createdNode, (t) =>
                        // {
                        //     t.setStyle(mergeCss(t.getStyle() || '', style));
                        // });
                    },
                };
            },
        };
    };
}

const styles: (keyof CSSStyleDeclaration)[] = ['fontSize', 'color', 'backgroundColor'];

function cssStyleDeclarationToKebabCase(style: keyof CSSStyleDeclaration): string
{
    return String(style).replace(/([A-Z])/g, '-$1').toLowerCase();
}

function getStylesToApply(element: HTMLElement): string
{
    return styles.map(style =>
    {
        const value = element.style[style];
        if (value) { return `${cssStyleDeclarationToKebabCase(style)}: ${value}`; }
        return null;
    })
    .filter(Boolean).join('; ');
}

function getPatchStylesConverter
(
    original?: (node: HTMLElement) => DOMConversion | null,
)
{
    return (element: HTMLElement): DOMConversionOutput | null =>
    {
        const baseConverter = original?.(element);
        if (!baseConverter) { return null; }
        const baseOutput = baseConverter.conversion(element);
        if (!baseOutput) { return baseOutput; }
        const styles = getStylesToApply(element);
        if (!styles) { return baseOutput; }
        const output: DOMConversionOutput =
        {
            ...baseOutput,
            after: (childLexicalNodes: LexicalNode[]) =>
            {
                const nodes = baseOutput.after?.(childLexicalNodes) ?? childLexicalNodes;
                console.log('getPatchStylesConverter after styles=', styles);
                console.log('childLexicalNodes=', childLexicalNodes);
                for (const node of nodes)
                {
                    if ($isTextNode(node))
                    {
                        console.log('Patching TextNode style', styles);
                        // const existingStyle = node.getStyle();
                        node.setStyle(styles);
                    }
                }
                return nodes;
            },
            forChild: (childNode: LexicalNode, parent: LexicalNode | null | undefined) =>
            {
                const baseChild = baseOutput.forChild?.(childNode, parent);
                if (baseChild && $isTextNode(baseChild))
                {
                    baseChild.setStyle(styles);
                }
                return baseChild;
            }
        };
        return output;
    };
}

const base = TextNode.importDOM?.() ?? {};
export const htmlImportMap: DOMConversionMap =
{
    img: () => ({ conversion: $convertImageElement, priority: 4 }),
    strong: () => ({ conversion: getPatchStylesConverter(base.strong), priority: 3 }),
    b: () => ({ conversion: getPatchStylesConverter(base.b), priority: 3 }),
    u: () => ({ conversion: getPatchStylesConverter(base.u), priority: 3 }),
    em: () => ({ conversion: getPatchStylesConverter(base.em), priority: 3 }),
    i: () => ({ conversion: getPatchStylesConverter(base.i), priority: 3 }),
    s: () => ({ conversion: getPatchStylesConverter(base.s), priority: 3 }),
    a: () => ({ conversion: getPatchStylesConverter(base.a), priority: 3 }),
    span: () => ({ conversion: getPatchStylesConverter(base.span), priority: 3 })
};